<template>
  <span>
    <div v-if="isShowPrice" class="getDiscountPrice">
      <template v-if="PageDiscount">
        <Sf-price :regular="ProductPrice.regular ? $n(
          ProductPrice.regular,
          'currency'
        ) : ''
          " :special="$n(ProductPrice.special, 'currency')
      " style="--price-special-font-weight:600" />
        <SfButton v-if="showBtn && Discount && Discount.promo_code" class="sf-button--text" style="margin-left:5px;"
          @click="lingjuan()">{{ $t('claimCoupone') }}</SfButton>
      </template>
    </div>
    <div v-else class="getDiscountPrice">
      <Sf-price :regular="'???'
        " style="--price-special-font-weight:600" /> <SfButton class="sf-button--text" style="margin-left:5px;" @click="handleLoiginClick"> {{ $t('login.showPrice') }} </SfButton>
    </div>
  </span>
</template>
<script>
import { useGetDiscount, useClaimBenfitCode, useApiError, useWholesale, useCustomCoupon } from '@bee-hole/coms';
import {
  computed,
  onMounted,
  ref,
  onBeforeUnmount,
  onUpdated
} from "@nuxtjs/composition-api";
import { EventBus } from '@/plugins/eventBus';
import {
  SfPrice,
  SfButton
} from '@storefront-ui/vue';
import { useUiState } from '~/composables';
export default {
  name: 'getDiscount',
  props: {
    goods: {
      default: null
    },
    sku: {
      default: null
    },
    showBtn: {
      default: false
    },
    autoLing: {
      default: false
    }
  },
  setup(props, ctx) {
    const { set: setError } = useApiError();
    const { claimBenefitCode, claimResult } = useClaimBenfitCode();
    const { getDiscount } = useGetDiscount();
    const { customCouponList, result: couponList } = useCustomCoupon();
    const {
      toggleLoginModal,
    } = useUiState();
    const { result: pifaResult } = useWholesale(props.goods.goodId || props.goods.good_id);
    const DiscountRes = ref();
    const PageDiscount = ref();
    const getPifa = (sku) => {
      let pifa = null;
      const num = sku?.num || 1;
      // 通过他的start_num和end_num找到对应的批发价
      if (pifaResult.value && pifaResult.value?.length) {
        pifa = pifaResult.value.find((item) => {
          return item.start_num <= num && item.end_num >= num;
        });
      }
      return pifa;
    };
    const isShowPrice = ref(true)
    const token = computed(() => {
      return ctx?.root?.$cookies.get('token');
    })
    const lingjuan = async () => {
      if (DiscountRes.value && DiscountRes.value.promo_code) {
        const res = await claimBenefitCode({ promo_code: DiscountRes.value.promo_code,auto: true });
        if (claimResult.value && claimResult.value.activity_name) {
          setError({
            code: 0,
            message: ctx.root.$t('claimCouponeSuccess', { name: claimResult.value.activity_name })
          });
        } else if (res.code !==0) {
          setError(res);
        }
      }
    };
    const newLingQu = (auto = false) => {
      if (couponList.value && couponList.value?.list?.length) {
        const pp = [];
        couponList.value.list.forEach(async (item) => {
          if (item.promotion_code) {
            await claimBenefitCode({ promo_code: item.promotion_code, auto });
          }
          if (claimResult.value && claimResult.value.activity_name) {
            setError({
              code: 0,
              message: ctx.root.$t('claimCouponeSuccess', { name: claimResult.value.activity_name }),
              time: 10000
            });
          }
        });
        try {
          Promise.all(pp).then(() => {
            customCouponList();
          });
        } catch (e) {
          console.log('couponListErr', e);
        }
      }
    };
    const ProductPrice = ref();
    const jisuanGoods = (discount_ratio) => {
      if (discount_ratio < 1 && discount_ratio) {
        ProductPrice.value = {
          regular: props.goods.priceMin,
          special: (props.goods.priceMin * discount_ratio).toFixed(2),
          source: 'goods1'
        };
      } else {
        ProductPrice.value = {
          regular: 0,
          special: props.goods.priceMin,
          source: 'goods2'
        };
      }
    };
    const jisuanSku = (sku, discount_ratio) => {
      const pifa = getPifa(sku);
      if (discount_ratio < 1 && discount_ratio) {
        let specialPrice = 0;
        let regularPrice = 0;
        // type 1 为百分比 2为固定金额
        if (pifa?.type === 1) {
          specialPrice = (Number((sku.originalPrice * pifa.price / 100 * discount_ratio).toFixed(2)) * props.goods.exchangeRate).toFixed(2);
          regularPrice = (Number((sku.originalPrice * pifa.price * props.goods.exchangeRate / 100).toFixed(2))).toFixed(2);
        } else if (pifa?.type === 2) {
          specialPrice = ((pifa.price * discount_ratio) * (1)).toFixed(2);
          regularPrice = (Number(pifa.price)).toFixed(2);
        } else {
          specialPrice = (sku.price * discount_ratio * (1)).toFixed(2);
          regularPrice = (Number(sku.price)).toFixed(2);
        }
        ProductPrice.value = {
          regular: regularPrice,
          special: specialPrice,
          source: 'sku1'
        };
      } else {
        let specialPrice = 0;
        if (pifa?.type === 1) {
          specialPrice = ((sku.originalPrice * pifa.price / 100).toFixed(2) * props.goods.exchangeRate * (1)).toFixed(2);
        } else if (pifa?.type === 2) {
          specialPrice = (pifa.price).toFixed(2);
        } else {
          specialPrice = (Number(sku.price)).toFixed(2);
        }
        ProductPrice.value = {
          regular: 0,
          special: specialPrice,
          source: 'sku2'
        };
      }
    };
    const initData = async (sku) => {
      let discount_ratio = 1;
      if (props.goods) {
        const goodId = props.goods.goodId || props.goods.good_id;
        if (goodId) {
          DiscountRes.value = await getDiscount({ good_id: goodId });
        }
        if (DiscountRes.value?.discount_ratio && DiscountRes.value?.promo_code_type === 1) {
          discount_ratio = 1 - DiscountRes.value.discount_ratio;
        }
        PageDiscount.value = discount_ratio * 100;
      }
      if (sku) {
        if (Number(sku.price) + '' === '-1' || sku.originalPrice + '' === '-1') {
          isShowPrice.value = false;
          return false;
        } else {
          isShowPrice.value = true;
        }
        jisuanSku(sku, discount_ratio);
      } else if (props.goods) {
        if (Number(props.goods.priceMin) +'' === '-1'){
          isShowPrice.value = false;
          return false;
        } else {
          isShowPrice.value = true;
        }
        jisuanGoods(discount_ratio);
      } else {
        ProductPrice.value = {
          regular: 0
        };
      }
    };
    const getEventFunction = () => {
      EventBus.$on('SkuChange', async (data) => {
        if (data && data.sku && data.sku.skuId) {
          initData(data.sku);
        }
      });
    };
    const handleLoiginClick = ()=>{
      toggleLoginModal();
    }
    onBeforeUnmount(() => {
      EventBus.$off('SkuChange');
    });
    // onUpdated(() => {
    //   // getEventFunction();
    // });
    onMounted(async () => {
      if (props.sku) {
        initData(props.sku);
      } else {
        initData();
      }
      getEventFunction();
      if (props.autoLing) {
        setTimeout(async () => {
          if (ctx?.root?.$cookies.get('token')) {
            await customCouponList();
            newLingQu();
          }
        }, 1000);
      }
    });
    return {
      ProductPrice,
      PageDiscount,
      Discount: computed(() => DiscountRes.value),
      couponList,
      lingjuan,
      handleLoiginClick,
      isShowPrice
    };
  },
  components: {
    SfPrice,
    SfButton
  }
};
</script>
<style lang="scss" scoped>
.getDiscountPrice {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;

  .sf-price {
    align-items: baseline;
    flex-direction: row-reverse;

    * {
      line-height: 18px;
    }

    .sf-price__old {
      margin-left: 5px;
    }
  }
}
</style>
